const one_time_token = {
    token_not_found: 'توکن {{token}} یافت نشد.',
    email_mismatch: 'ایمیل با توکن داده‌شده مطابقت ندارد.',
    token_expired: 'توکن منقضی شده است.',
    token_consumed: 'توکن مصرف شده است.',
    token_revoked: 'توکن لغو شده است.',
    cannot_reactivate_token: 'نمی‌توان توکن را دوباره فعال کرد.',
};
export default Object.freeze(one_time_token);
